import { Routes } from '@angular/router';
import { StoreResolver } from '@speedy/core';

export enum AppRoutePath {
  Dashboard = 'dashboard',
  Auth = 'auth',
  Checkout = 'checkout',
}

export const routes: Routes = [
  {
    path: ':store',
    resolve: {
      data: StoreResolver,
    },
    children: [
      {
        path: '',
        loadChildren: () => import('./main/main.routing').then((m) => m.MainRoutes),
      },
      {
        path: AppRoutePath.Checkout,
        loadChildren: () =>
          import('./checkout/checkout.routing').then((m) => m.CheckoutRoutes),
      },
      {
        path: AppRoutePath.Auth,
        loadChildren: () => import('./auth/auth.routing').then((m) => m.AuthRoutes),
      },
      { path: '**', redirectTo: 'notfound' },
    ],
  },
];
